module.exports = __webpack_public_path__ + "I7M2@2x.jpg?771dd036c1df0e854a7c85b9789645eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I7M2@2x.jpg
// module id = 101
// module chunks = 0